module.exports = __webpack_public_path__ + "img/certificado-git.737e5113.jpg";